/**
 * @Author: zachalam
 * @Date:   2017-01-04T13:20:10-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T16:35:07-07:00
 */

import React, { Component } from "react";
import glamorous, { Div, Span } from "glamorous";
import Container from "../../blocks/Container";
import Select from "../../common/Select";
import SearchLocationInput from "./SearchLocationInput";
import { extractLocationData } from "../../../common";
import { dimensions } from "../../../style/index";

const SearchContainer = glamorous.div({
  backgroundColor: "#443c5b",
  color: "#fff",
  paddingTop: "1.5em",
  paddingBottom: "1.5em",
  fontSize: 24,
  [dimensions.SCREEN_MAX_SM] : {
    paddingTop: 8,
    paddingBottom: 8,
  }
});

var searchIcon = {
  height: "1em",
  width: "1em",
  verticalAlign: "middle",
  fill: "#c2c2c2"
};

const Icon = glamorous.div({
  [dimensions.SCREEN_MAX_SM]: {
    display: "none"
  }
});

const Search = glamorous.div({
  fontFamily: "'PT Serif', serif",
  display: "flex",
  [dimensions.SCREEN_MAX_SM]: {
    flexDirection: "column"
  }
});

const Text = glamorous.span({
  flexShrink: 0,
  [dimensions.SCREEN_MAX_XXS]: {
    fontSize: 22,
    lineHeight: "32px"
  }
})

class SearchResultsTopBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: this.props.search.filters,
      filterMembersLivingIn: this.props.search.filterMembersLivingIn,
      maxLocationInputLength: null
    };
    this.runNewSearch = this.runNewSearch.bind(this);
    this.saveLocation = this.saveLocation.bind(this);
    this.filterTypeChangeHandler = this.filterTypeChangeHandler.bind(this);
    this.handleInputResize = this.handleInputResize.bind(this);
  }

  componentDidMount() {
    // 34px accounts for length of text ("in"/"to") next to location dropdown
    // The "in"/"to" text is in the same flex container
    this.setState({maxLocationInputLength: document.getElementById('search-results-location-input').offsetWidth - 34})
    window.addEventListener('resize', this.handleInputResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleInputResize)
  }

  handleInputResize = () => {
    this.setState({ maxLocationInputLength: document.getElementById('search-results-location-input').offsetWidth - 34})
  }

  // run new Search - which type do we run?
  runNewSearch = () => {
    // save filters then run new search
    // save filters.
    this.props.saveFilters({
      formData: this.state.formData,
      filterMembersLivingIn: this.state.filterMembersLivingIn
    });

    if (this.state.filterMembersLivingIn) this.props.refreshProfile();
    else {
      const { latitude, longitude } = this.state.formData;

      //this.props.getTripDestinationPhoto(latitude, longitude);
      this.props.refreshTrips();
    }
  };

  saveLocation = place => {
    // apply location to state
    let loc = extractLocationData(place);
    this.setState({ formData: { ...this.state.formData, ...loc } }, () => {
      // save location to filters
      // apply to search
      this.runNewSearch();
    });
  };

  filterTypeChangeHandler = e => {
    // save in current state
    let filterMembersLivingIn = Boolean(e.target.value === "true");
    this.setState({ filterMembersLivingIn }, () => {
      this.runNewSearch();
    });
  };

  render() {
    return (
      <SearchContainer>
        <Container>
          <Search>
            <Div display="flex" flexShrink={0}>
              <Icon>
                <svg viewBox="0 0 64 64" style={searchIcon}>
                  <path d="M58.2507618,54.011855 L47.1307618,42.901855 C54.6614516,33.1568984 53.3995835,19.2527629 44.2375776,11.0227499 C35.0755718,2.79273678 21.1162089,3.02400069 12.2318483,11.5529868 C3.34748779,20.0819729 2.54688373,34.0202773 10.3962404,43.5104336 C18.2455971,53.0005898 32.0866721,54.8286867 42.1307618,47.701855 L53.3307618,58.901855 C53.6778536,59.2499319 54.1492028,59.4455625 54.6407618,59.4455625 C55.1323208,59.4455625 55.60367,59.2499319 55.9507618,58.901855 L58.2007618,56.651855 C58.5616838,56.3107507 58.7703131,55.8388629 58.7797169,55.3423466 C58.7891206,54.8458303 58.598509,54.3663811 58.2507618,54.011855 L58.2507618,54.011855 Z M11.2861427,28.591855 C11.2861427,19.0955291 18.9844359,11.3972359 28.4807618,11.3972359 C37.9770877,11.3972359 45.6753809,19.0955291 45.6753809,28.591855 C45.6753809,38.0881809 37.9770877,45.7864741 28.4807618,45.7864741 C18.9844359,45.7864741 11.2861427,38.0881809 11.2861427,28.591855 L11.2861427,28.591855 Z" />
                </svg>
                &nbsp;&nbsp;
              </Icon>
              <Text>I am looking for &nbsp;</Text>
              <Select
                value={this.state.filterMembersLivingIn}
                onChange={this.filterTypeChangeHandler}
                arrow="light"
                dropdownStyle="mt-purple"
              >
                <option value={true}>People</option>
                <option value={false}>Trips</option>
              </Select>
              &nbsp;&nbsp;
            </Div>
            <Div display="flex" flexGrow={1}>
              <Text>{this.state.filterMembersLivingIn ? 'in' : 'to'} &nbsp;</Text>
              <Div id="search-results-location-input" flexGrow={1}>
              <SearchLocationInput
                saveLocation={this.saveLocation}
                searchFilters={this.props.search.filters}
                filterMembersLivingIn={true}
                autoResize={true}
                maxInputLength={this.state.maxLocationInputLength}
              />
              </Div>
            </Div>
          </Search>
        </Container>
      </SearchContainer>
    );
  }
}

export default SearchResultsTopBar;



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchResultsTopBar.jsx